(function () {
  function getHeaderOffset() {
    var header = document.querySelector('header[is="basic-header"]');
    return header ? Math.round(header.getBoundingClientRect().height) : 0;
  }

  function initPageSectionNav(bar) {
    bar.querySelectorAll('.page-section-nav__link').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var anchor = link.getAttribute('href');
        if (!anchor || anchor.charAt(0) !== '#') return;

        var target = document.querySelector(anchor);
        if (!target) return;

        event.preventDefault();
        var top = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  document.querySelectorAll('.page-section-nav__bar').forEach(initPageSectionNav);
})();
